<template>
  <b-tabs>
    <b-tab
      title="Origins"
      :active="activeTab === 0"
      @click="changeActiveTab(0)"
    />
    <b-tab
      title="Origin Groups"
      :active="activeTab === 1"
      @click="changeActiveTab(1)"
    />
    <b-tab
      title="Healthchecks"
      :active="activeTab === 2"
      @click="changeActiveTab(2)"
    />
  </b-tabs>
</template>
<script>
export default {
  name: 'HostDetailsSidebar',
  props: {
    tab: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      activeTab: 0,
    }
  },
  created() {
    this.activeTab = this.tab
  },
  methods: {
    changeActiveTab(val) {
      this.$emit('activeTab', val)
      this.activeTab = val
    },
  },
}
</script>
